// Mirror of tectra-core/internal/featureflags/registry.go. Keys and defaults
// MUST match the Go registry. Drift is surfaced (but not prevented) by the
// banner on /manager/admin/feature-flags — keep this file in sync when
// adding, removing, or renaming flags in the Go registry.
//
// FLAGS is intentionally empty: "incidents" was the only flag ever
// registered here, and it was removed in surface-reduction phase 3 (task 5)
// once the incidents module it gated was fully deleted. The machinery — this
// mirror, the admin FlagsTable/DriftBanner, and the useFeatureFlag hook — is
// kept in place, ready for the next flag. Both sides (this file and the Go
// registry) must stay in sync.

export const FLAGS = {}
